import { Button } from "@pushpress/pushpress-ui";
import { RefreshCw } from "lucide-react";
import { PeopleType } from "../../types";
export default function ErrorState({
  refetch,
  peopleType,
}: {
  refetch: () => void;
  peopleType: PeopleType;
}) {
  return (
    <>
      <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-8 tw-text-center">
        <h4 className="tw-mb-2">Error loading {peopleType}</h4>
        <p className="tw-text-neutral-500 tw-mb-6">
          This could be due to a network issue or a temporary problem on our
          end.
        </p>
        <div className="tw-mt-2 tw-flex tw-items-center tw-justify-center tw-gap-x-4">
          <Button
            data-testid="go-back-home-button"
            onClick={() => {
              window.location.href = "/";
            }}
          >
            Go back home
          </Button>
          <Button
            data-testid="retry-button"
            variant="outline"
            onClick={() => refetch()}
          >
            Retry
            <RefreshCw className="tw-ml-2 tw-h-4 tw-w-4" />
          </Button>
        </div>
      </div>
    </>
  );
}
